
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta } from "/app/pages/b2b.vue?macro=true";
import { default as devdjDB5yG1649kY6yMbqWxgn7OuNYXY2QzAQAi7xiCGLAMeta } from "/app/pages/dev.vue?macro=true";
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as tosUnbYuckNIzZ5Ba0gelRujodHJ3WLIwNKFtCVeDrd474Meta } from "/app/pages/tos.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as imprinthkouq5hSidrpTSuflE7DpDLLzD4EE_45s4nlZ8qXwh8sIMeta } from "/app/pages/imprint.vue?macro=true";
import { default as pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta } from "/app/pages/pricing.vue?macro=true";
import { default as privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_45u0Meta } from "/app/pages/privacy.vue?macro=true";
import { default as featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta } from "/app/pages/features.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as warmingupMnr4SdCQ2et9WuOA79Cs8Dj_OBTQ1036rKKN2fhbnikMeta } from "/app/pages/warmingup.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as indexQ_45p_R8nWqy4cZICdOG47zZGdB894pqt8jkBF_45IT0qhIMeta } from "/app/pages/home/index.vue?macro=true";
import { default as indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta } from "/app/pages/wiki/index.vue?macro=true";
import { default as indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta } from "/app/pages/tools/index.vue?macro=true";
import { default as cancellation8CFKB6vkC2GT4V6k5l85_452MRlppTlHzRqvNwwZIF9uAMeta } from "/app/pages/cancellation.vue?macro=true";
import { default as confirm_45emailmOQPuQsguw3wpmY58YmTJo9FKxdfbof0kTYkEAlEayEMeta } from "/app/pages/confirm-email.vue?macro=true";
import { default as indexVx65biFkALNIci1zzKZ3d0OHFh0_HEts7VMKczcHueAMeta } from "/app/pages/home/settings/index.vue?macro=true";
import { default as theme1cH5MLEJvOONGqMYGGotTpm_45qVivrq6F_45SxQkS6jp_AMeta } from "/app/pages/home/settings/theme.vue?macro=true";
import { default as accountO2BlFkJIUbW11_45ZwGZyDPVl1rqmC8CcZ_6AdQAn3FVYMeta } from "/app/pages/home/settings/account.vue?macro=true";
import { default as affiliatesw3vdh_BruIcpunhV9nAT5zLgFWchtDj_sIF0j9M0rBUMeta } from "/app/pages/home/settings/affiliates.vue?macro=true";
import { default as blogsLpbRwjCCRst86oQIg_nPiKA_w0D5dg0j8uOHuTADyx0Meta } from "/app/pages/home/settings/admin/blogs.vue?macro=true";
import { default as rolesSDqQahvXZ8fZlOthsYLnyRdTZAZ_X3YFDhUaT96kXR4Meta } from "/app/pages/home/settings/admin/roles.vue?macro=true";
import { default as usersymV02S7AQE09GEmv_459Mm219AUa_Sa5LC9RxpqJIvdxIMeta } from "/app/pages/home/settings/admin/users.vue?macro=true";
import { default as flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta } from "/app/pages/home/settings/flightschool.vue?macro=true";
import { default as notificationsbiHMOzica0CAku1pCsUX9O66BJxIbueEk6RR5XGHjvQMeta } from "/app/pages/home/settings/notifications.vue?macro=true";
import { default as subscriptionsJjhQNuTkSKZvtKTTQYzKs4MFN0OU4a7pchlEUuW_45dw4Meta } from "/app/pages/home/settings/subscriptions.vue?macro=true";
import { default as products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta } from "/app/pages/home/settings/admin/products.vue?macro=true";
import { default as scenariosrpiTooaKF8Nr9hq1Mx543qJUuvi31q1h_3Fa6HAj71UMeta } from "/app/pages/home/settings/admin/scenarios.vue?macro=true";
import { default as payment_45methodsaPv9bJvzMKlSGk3feMz0wP1mUfkr8UAbqSHNPOZwnC8Meta } from "/app/pages/home/settings/payment-methods.vue?macro=true";
import { default as activitieskw4f_45D0Y_452f_KDVY0X1be0SelnKKo91L5przdxdkn6gMeta } from "/app/pages/home/settings/admin/activities.vue?macro=true";
import { default as flightschoolsU9wmDw7EmwFssK0sZhg_l8smcqyWzwHYi1Vdnp5QrlAMeta } from "/app/pages/home/settings/admin/flightschools.vue?macro=true";
import { default as transmissionsUXqIqd9g6C3e6JKNtIiCwDQonBmsbss2_45KdjJdldlG4Meta } from "/app/pages/home/settings/admin/transmissions.vue?macro=true";
import { default as settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta } from "/app/pages/home/settings.vue?macro=true";
import { default as forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as proceduresHNlWfk6SK18XWNE6erAZB2_45u8AlNzf7R6nMEeH8CdwgMeta } from "/app/pages/wiki/procedures.vue?macro=true";
import { default as indexW7_QmpKzZwgulw6Co_q1glrYDmBLA_45PTzNOdPHETWIEMeta } from "/app/pages/home/school/index.vue?macro=true";
import { default as complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta } from "/app/pages/home/complete-setup.vue?macro=true";
import { default as coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta } from "/app/pages/home/school/courses.vue?macro=true";
import { default as _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta } from "/app/pages/product/[[product]].vue?macro=true";
import { default as simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta } from "/app/pages/home/school/simulator.vue?macro=true";
import { default as _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta } from "/app/pages/profile/[...username].vue?macro=true";
import { default as indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta } from "/app/pages/tools/aerodrome/index.vue?macro=true";
import { default as indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta } from "/app/pages/tools/frequency/index.vue?macro=true";
import { default as _91icao_93d08hvSepwj_cT6iE3GZK26cTPpBMYpjUDg8CH_R9BiUMeta } from "/app/pages/tools/aerodrome/[icao].vue?macro=true";
import { default as _91icao_93D0MGNpW8DioHbr17O_45Sx_AQc_451dnrFUWZL4Ylq81rksMeta } from "/app/pages/tools/frequency/[icao].vue?macro=true";
import { default as index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta } from "/app/pages/tools/flightschool/index.vue?macro=true";
import { default as indexPNCnWdQAFO1tMbEz1leGuWjAV1LL8FlxzebsPUseNaQMeta } from "/app/pages/home/school/lections/index.vue?macro=true";
import { default as _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta } from "/app/pages/home/school/scenarios/[id].vue?macro=true";
import { default as indexUeHanNKbBTqZdX2OQ9t_SjCr2bqTxUQdLeMrkQujy2wMeta } from "/app/pages/home/school/syllabus/index.vue?macro=true";
import { default as indexj6YLQLkprw6TVyw2HkwdAy0qc9GdhbCJYrcpkFR6PkwMeta } from "/app/pages/home/school/training/index.vue?macro=true";
import { default as indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta } from "/app/pages/home/school/questions/index.vue?macro=true";
import { default as index_0WapMMTF1480iJPuPgRMrBtM1yMO1GcEfmCSm5x0xoMeta } from "/app/pages/home/school/scenarios/index.vue?macro=true";
import { default as _91school_93S8aNTfFhZNWoHoWYCDftpTPOSpyhvY6ffGehZPgVcHgMeta } from "/app/pages/tools/flightschool/[school].vue?macro=true";
import { default as spellingXOi3_LwNiFvWzJd7UqnfAhCnn_45D5gemUIVMyvzFaJg0Meta } from "/app/pages/home/school/training/spelling.vue?macro=true";
import { default as lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta } from "/app/pages/home/school/lections/lection-[id].vue?macro=true";
import { default as lection_45old_451IAi7I_b37pKuqHJicK0TzEs1evdFJV5YJZvbI_rkj_kMeta } from "/app/pages/home/school/lections/lection-old-1.vue?macro=true";
import { default as lection_45old_452lNAuY_45h0coVA1JzqFyP_45UyClasCy8qmP8onkkA1PAFAMeta } from "/app/pages/home/school/lections/lection-old-2.vue?macro=true";
import { default as lection_45old_453n6ohDp4AGRHn24ltFroyAo40I98BhsD7j1wXNWgoN8wMeta } from "/app/pages/home/school/lections/lection-old-3.vue?macro=true";
import { default as lection_45old_454mkTsQ9KELrRb42_45nIfI16Jkf1jeCyLd67SToBFAHFJoMeta } from "/app/pages/home/school/lections/lection-old-4.vue?macro=true";
import { default as lection_45old_4557MQ1vwUSHRfGlZQz1TF9SGB8_GZqQwNPONfWRujSCdUMeta } from "/app/pages/home/school/lections/lection-old-5.vue?macro=true";
import { default as lection_45old_4569BliQv_UPNO6OrS5W3cajToiHwKa_45iGLb3okDyoPyrsMeta } from "/app/pages/home/school/lections/lection-old-6.vue?macro=true";
import { default as indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta } from "/app/pages/home/school/questions/[license]/index.vue?macro=true";
import { default as indexHfgkwrchuuP1VdZ7P4H26dWRTzRe7pZ8WqvUONYzL7sMeta } from "/app/pages/home/school/questions/[license]/exampreparation/index.vue?macro=true";
import { default as indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta } from "/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue?macro=true";
import { default as index5zDmUjHzzWMBuzUXjOeYMxomexAwmuWD0fENn01sL38Meta } from "/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue?macro=true";
import { default as _91completion_93Caq8lVEcZOm9_udTYpcnocS5O79thXONtIesr3NPKGAMeta } from "/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue?macro=true";
import { default as component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta } from "/app/node_modules/.pnpm/nuxt@3.20.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compile_f3e1875dcb330f8c09d4b408e89c27d4/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o } from "/app/node_modules/.pnpm/nuxt@3.20.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compile_f3e1875dcb330f8c09d4b408e89c27d4/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "b2b___en___default",
    path: "/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___en",
    path: "/en/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___de",
    path: "/de/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___at",
    path: "/at/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___es",
    path: "/es/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___uk",
    path: "/uk/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___ru",
    path: "/ru/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___ja",
    path: "/ja/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___it",
    path: "/it/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___nl",
    path: "/nl/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___pl",
    path: "/pl/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___fr",
    path: "/fr/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "dev___en___default",
    path: "/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___en",
    path: "/en/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___de",
    path: "/de/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___at",
    path: "/at/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___es",
    path: "/es/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___uk",
    path: "/uk/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___ru",
    path: "/ru/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___ja",
    path: "/ja/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___it",
    path: "/it/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___nl",
    path: "/nl/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___pl",
    path: "/pl/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___fr",
    path: "/fr/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "faq___en___default",
    path: "/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___de",
    path: "/de/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___at",
    path: "/at/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___uk",
    path: "/uk/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ja",
    path: "/ja/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___it",
    path: "/it/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___nl",
    path: "/nl/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___pl",
    path: "/pl/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___fr",
    path: "/fr/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "tos___en___default",
    path: "/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___en",
    path: "/en/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___de",
    path: "/de/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___at",
    path: "/at/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___es",
    path: "/es/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___uk",
    path: "/uk/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___ru",
    path: "/ru/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___ja",
    path: "/ja/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___it",
    path: "/it/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___nl",
    path: "/nl/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___pl",
    path: "/pl/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___fr",
    path: "/fr/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___at",
    path: "/at",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___at",
    path: "/at/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___uk",
    path: "/uk/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___nl",
    path: "/nl/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___pl",
    path: "/pl/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "imprint___en___default",
    path: "/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___en",
    path: "/en/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___de",
    path: "/de/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___at",
    path: "/at/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___es",
    path: "/es/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___uk",
    path: "/uk/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___ru",
    path: "/ru/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___ja",
    path: "/ja/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___it",
    path: "/it/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___nl",
    path: "/nl/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___pl",
    path: "/pl/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___fr",
    path: "/fr/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "pricing___en___default",
    path: "/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___en",
    path: "/en/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___de",
    path: "/de/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___at",
    path: "/at/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___es",
    path: "/es/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___uk",
    path: "/uk/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___ru",
    path: "/ru/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___ja",
    path: "/ja/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___it",
    path: "/it/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___nl",
    path: "/nl/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___pl",
    path: "/pl/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___fr",
    path: "/fr/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "privacy___en___default",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___de",
    path: "/de/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___at",
    path: "/at/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___es",
    path: "/es/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___uk",
    path: "/uk/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___ru",
    path: "/ru/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___ja",
    path: "/ja/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___it",
    path: "/it/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___nl",
    path: "/nl/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___fr",
    path: "/fr/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "features___en___default",
    path: "/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___en",
    path: "/en/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___de",
    path: "/de/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___at",
    path: "/at/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___es",
    path: "/es/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___uk",
    path: "/uk/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___ru",
    path: "/ru/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___ja",
    path: "/ja/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___it",
    path: "/it/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___nl",
    path: "/nl/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___pl",
    path: "/pl/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___fr",
    path: "/fr/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "register___en___default",
    path: "/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___at",
    path: "/at/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___uk",
    path: "/uk/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___ru",
    path: "/ru/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___ja",
    path: "/ja/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___nl",
    path: "/nl/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___pl",
    path: "/pl/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "slug___en___default",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___ru",
    path: "/ru/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___pl",
    path: "/pl/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "warmingup___en___default",
    path: "/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___en",
    path: "/en/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___de",
    path: "/de/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___at",
    path: "/at/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___es",
    path: "/es/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___uk",
    path: "/uk/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___ru",
    path: "/ru/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___ja",
    path: "/ja/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___it",
    path: "/it/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___nl",
    path: "/nl/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___pl",
    path: "/pl/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___fr",
    path: "/fr/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "blog___en___default",
    path: "/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___at",
    path: "/at/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___uk",
    path: "/uk/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___ja",
    path: "/ja/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___nl",
    path: "/nl/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___pl",
    path: "/pl/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "home___en___default",
    path: "/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___de",
    path: "/de/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___at",
    path: "/at/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___es",
    path: "/es/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___uk",
    path: "/uk/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___ru",
    path: "/ru/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___ja",
    path: "/ja/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___it",
    path: "/it/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___nl",
    path: "/nl/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___pl",
    path: "/pl/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___fr",
    path: "/fr/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "wiki___en___default",
    path: "/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___en",
    path: "/en/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___de",
    path: "/de/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___at",
    path: "/at/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___es",
    path: "/es/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___uk",
    path: "/uk/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___ru",
    path: "/ru/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___ja",
    path: "/ja/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___it",
    path: "/it/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___nl",
    path: "/nl/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___pl",
    path: "/pl/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___fr",
    path: "/fr/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "Tools___en___default",
    path: "/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___en",
    path: "/en/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___de",
    path: "/de/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___at",
    path: "/at/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___es",
    path: "/es/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___uk",
    path: "/uk/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___ru",
    path: "/ru/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___ja",
    path: "/ja/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___it",
    path: "/it/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___nl",
    path: "/nl/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___pl",
    path: "/pl/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___fr",
    path: "/fr/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "cancellation___en___default",
    path: "/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___en",
    path: "/en/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___de",
    path: "/de/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___at",
    path: "/at/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___es",
    path: "/es/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___uk",
    path: "/uk/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___ru",
    path: "/ru/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___ja",
    path: "/ja/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___it",
    path: "/it/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___nl",
    path: "/nl/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___pl",
    path: "/pl/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___fr",
    path: "/fr/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "confirm-email___en___default",
    path: "/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___en",
    path: "/en/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___de",
    path: "/de/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___at",
    path: "/at/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___es",
    path: "/es/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___uk",
    path: "/uk/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___ru",
    path: "/ru/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___ja",
    path: "/ja/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___it",
    path: "/it/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___nl",
    path: "/nl/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___pl",
    path: "/pl/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___fr",
    path: "/fr/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___en___default",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___en___default",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___en___default",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___en___default",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___en___default",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___en___default",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___en___default",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___en___default",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___en___default",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___en___default",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___en___default",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___en___default",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___en___default",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___en___default",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___en___default",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___en___default",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/en/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___en",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___en",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___en",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___en",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___en",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___en",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___en",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___en",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___en",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___en",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___en",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___en",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___en",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___en",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___en",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___en",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/de/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___de",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___de",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___de",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___de",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___de",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___de",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___de",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___de",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___de",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___de",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___de",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___de",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___de",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___de",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___de",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___de",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/at/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___at",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___at",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___at",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___at",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___at",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___at",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___at",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___at",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___at",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___at",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___at",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___at",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___at",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___at",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___at",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___at",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/es/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___es",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___es",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___es",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___es",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___es",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___es",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___es",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___es",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___es",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___es",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___es",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___es",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___es",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___es",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___es",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___es",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/uk/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___uk",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___uk",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___uk",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___uk",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___uk",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___uk",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___uk",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___uk",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___uk",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___uk",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___uk",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___uk",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___uk",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___uk",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___uk",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___uk",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/ru/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___ru",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___ru",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___ru",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___ru",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___ru",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___ru",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___ru",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___ru",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___ru",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___ru",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___ru",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___ru",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___ru",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___ru",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___ru",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___ru",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/ja/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___ja",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___ja",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___ja",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___ja",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___ja",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___ja",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___ja",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___ja",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___ja",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___ja",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___ja",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___ja",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___ja",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___ja",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___ja",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___ja",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/it/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___it",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___it",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___it",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___it",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___it",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___it",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___it",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___it",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___it",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___it",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___it",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___it",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___it",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___it",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___it",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___it",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/nl/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___nl",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___nl",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___nl",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___nl",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___nl",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___nl",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___nl",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___nl",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___nl",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___nl",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___nl",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___nl",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___nl",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___nl",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___nl",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___nl",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/pl/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___pl",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___pl",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___pl",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___pl",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___pl",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___pl",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___pl",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___pl",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___pl",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___pl",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___pl",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___pl",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___pl",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___pl",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___pl",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___pl",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/fr/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___fr",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___fr",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___fr",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___fr",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___fr",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___fr",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___fr",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___fr",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___fr",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___fr",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-products___fr",
    path: "admin/products",
    meta: products2juXdcMJWAWyVgCHz53hGhpG2OdCQKFNcGbq5VqybecMeta || {},
    component: () => import("/app/pages/home/settings/admin/products.vue")
  },
  {
    name: "home-settings-admin-scenarios___fr",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___fr",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___fr",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-flightschools___fr",
    path: "admin/flightschools",
    component: () => import("/app/pages/home/settings/admin/flightschools.vue")
  },
  {
    name: "home-settings-admin-transmissions___fr",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: "forgot-password___en___default",
    path: "/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___at",
    path: "/at/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___uk",
    path: "/uk/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ru",
    path: "/ru/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ja",
    path: "/ja/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___it",
    path: "/it/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___nl",
    path: "/nl/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___pl",
    path: "/pl/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "wiki-procedures___en___default",
    path: "/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___en",
    path: "/en/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___de",
    path: "/de/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___at",
    path: "/at/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___es",
    path: "/es/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___uk",
    path: "/uk/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___ru",
    path: "/ru/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___ja",
    path: "/ja/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___it",
    path: "/it/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___nl",
    path: "/nl/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___pl",
    path: "/pl/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___fr",
    path: "/fr/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "home-school___en___default",
    path: "/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___en",
    path: "/en/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___de",
    path: "/de/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___at",
    path: "/at/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___es",
    path: "/es/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___uk",
    path: "/uk/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___ru",
    path: "/ru/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___ja",
    path: "/ja/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___it",
    path: "/it/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___nl",
    path: "/nl/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___pl",
    path: "/pl/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___fr",
    path: "/fr/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-complete-setup___en___default",
    path: "/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___en",
    path: "/en/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___de",
    path: "/de/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___at",
    path: "/at/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___es",
    path: "/es/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___uk",
    path: "/uk/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___ru",
    path: "/ru/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___ja",
    path: "/ja/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___it",
    path: "/it/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___nl",
    path: "/nl/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___pl",
    path: "/pl/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___fr",
    path: "/fr/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-school-courses___en___default",
    path: "/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___en",
    path: "/en/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___de",
    path: "/de/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___at",
    path: "/at/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___es",
    path: "/es/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___uk",
    path: "/uk/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___ru",
    path: "/ru/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___ja",
    path: "/ja/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___it",
    path: "/it/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___nl",
    path: "/nl/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___pl",
    path: "/pl/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___fr",
    path: "/fr/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "product-product___en___default",
    path: "/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___en",
    path: "/en/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___de",
    path: "/de/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___at",
    path: "/at/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___es",
    path: "/es/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___uk",
    path: "/uk/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___ru",
    path: "/ru/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___ja",
    path: "/ja/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___it",
    path: "/it/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___nl",
    path: "/nl/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___pl",
    path: "/pl/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "product-product___fr",
    path: "/fr/product/:product?",
    meta: _91_91product_93_93mJ5vzJ3FSSY4On1a_uoKbn_hV2l_45XdixYpx6YQhfG4AMeta || {},
    component: () => import("/app/pages/product/[[product]].vue")
  },
  {
    name: "home-school-simulator___en___default",
    path: "/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___en",
    path: "/en/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___de",
    path: "/de/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___at",
    path: "/at/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___es",
    path: "/es/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___uk",
    path: "/uk/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___ru",
    path: "/ru/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___ja",
    path: "/ja/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___it",
    path: "/it/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___nl",
    path: "/nl/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___pl",
    path: "/pl/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___fr",
    path: "/fr/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "profile-username___en___default",
    path: "/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___en",
    path: "/en/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___de",
    path: "/de/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___at",
    path: "/at/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___es",
    path: "/es/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___uk",
    path: "/uk/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___ru",
    path: "/ru/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___ja",
    path: "/ja/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___it",
    path: "/it/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___nl",
    path: "/nl/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___pl",
    path: "/pl/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___fr",
    path: "/fr/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "tools-aerodrome___en___default",
    path: "/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___en",
    path: "/en/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___de",
    path: "/de/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___at",
    path: "/at/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___es",
    path: "/es/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___uk",
    path: "/uk/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___ru",
    path: "/ru/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___ja",
    path: "/ja/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___it",
    path: "/it/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___nl",
    path: "/nl/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___pl",
    path: "/pl/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___fr",
    path: "/fr/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-frequency___en___default",
    path: "/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___en",
    path: "/en/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___de",
    path: "/de/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___at",
    path: "/at/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___es",
    path: "/es/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___uk",
    path: "/uk/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___ru",
    path: "/ru/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___ja",
    path: "/ja/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___it",
    path: "/it/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___nl",
    path: "/nl/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___pl",
    path: "/pl/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___fr",
    path: "/fr/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-aerodrome-icao___en___default",
    path: "/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___en",
    path: "/en/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___de",
    path: "/de/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___at",
    path: "/at/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___es",
    path: "/es/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___uk",
    path: "/uk/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___ru",
    path: "/ru/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___ja",
    path: "/ja/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___it",
    path: "/it/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___nl",
    path: "/nl/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___pl",
    path: "/pl/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___fr",
    path: "/fr/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-frequency-icao___en___default",
    path: "/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___en",
    path: "/en/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___de",
    path: "/de/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___at",
    path: "/at/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___es",
    path: "/es/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___uk",
    path: "/uk/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___ru",
    path: "/ru/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___ja",
    path: "/ja/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___it",
    path: "/it/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___nl",
    path: "/nl/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___pl",
    path: "/pl/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___fr",
    path: "/fr/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-flightschool___en___default",
    path: "/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___en",
    path: "/en/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___de",
    path: "/de/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___at",
    path: "/at/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___es",
    path: "/es/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___uk",
    path: "/uk/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___ru",
    path: "/ru/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___ja",
    path: "/ja/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___it",
    path: "/it/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___nl",
    path: "/nl/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___pl",
    path: "/pl/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___fr",
    path: "/fr/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "home-school-lections___en___default",
    path: "/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___en",
    path: "/en/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___de",
    path: "/de/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___at",
    path: "/at/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___es",
    path: "/es/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___uk",
    path: "/uk/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___ru",
    path: "/ru/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___ja",
    path: "/ja/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___it",
    path: "/it/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___nl",
    path: "/nl/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___pl",
    path: "/pl/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___fr",
    path: "/fr/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "Scenario___en___default",
    path: "/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___en",
    path: "/en/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___de",
    path: "/de/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___at",
    path: "/at/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___es",
    path: "/es/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___uk",
    path: "/uk/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___ru",
    path: "/ru/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___ja",
    path: "/ja/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___it",
    path: "/it/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___nl",
    path: "/nl/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___pl",
    path: "/pl/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___fr",
    path: "/fr/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "home-school-syllabus___en___default",
    path: "/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___en",
    path: "/en/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___de",
    path: "/de/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___at",
    path: "/at/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___es",
    path: "/es/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___uk",
    path: "/uk/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___ru",
    path: "/ru/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___ja",
    path: "/ja/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___it",
    path: "/it/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___nl",
    path: "/nl/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___pl",
    path: "/pl/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-syllabus___fr",
    path: "/fr/home/school/syllabus",
    component: () => import("/app/pages/home/school/syllabus/index.vue")
  },
  {
    name: "home-school-training___en___default",
    path: "/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___en",
    path: "/en/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___de",
    path: "/de/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___at",
    path: "/at/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___es",
    path: "/es/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___uk",
    path: "/uk/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___ru",
    path: "/ru/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___ja",
    path: "/ja/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___it",
    path: "/it/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___nl",
    path: "/nl/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___pl",
    path: "/pl/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___fr",
    path: "/fr/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "Catalogs___en___default",
    path: "/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___en",
    path: "/en/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___de",
    path: "/de/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___at",
    path: "/at/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___es",
    path: "/es/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___uk",
    path: "/uk/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___ru",
    path: "/ru/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___ja",
    path: "/ja/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___it",
    path: "/it/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___nl",
    path: "/nl/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___pl",
    path: "/pl/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___fr",
    path: "/fr/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "home-school-scenarios___en___default",
    path: "/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___en",
    path: "/en/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___de",
    path: "/de/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___at",
    path: "/at/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___es",
    path: "/es/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___uk",
    path: "/uk/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___ru",
    path: "/ru/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___ja",
    path: "/ja/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___it",
    path: "/it/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___nl",
    path: "/nl/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___pl",
    path: "/pl/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___fr",
    path: "/fr/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "tools-flightschool-school___en___default",
    path: "/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___en",
    path: "/en/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___de",
    path: "/de/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___at",
    path: "/at/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___es",
    path: "/es/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___uk",
    path: "/uk/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___ru",
    path: "/ru/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___ja",
    path: "/ja/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___it",
    path: "/it/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___nl",
    path: "/nl/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___pl",
    path: "/pl/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___fr",
    path: "/fr/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "home-school-training-spelling___en___default",
    path: "/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___en",
    path: "/en/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___de",
    path: "/de/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___at",
    path: "/at/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___es",
    path: "/es/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___uk",
    path: "/uk/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___ru",
    path: "/ru/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___ja",
    path: "/ja/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___it",
    path: "/it/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___nl",
    path: "/nl/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___pl",
    path: "/pl/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___fr",
    path: "/fr/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "lection___en___default",
    path: "/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___en",
    path: "/en/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___de",
    path: "/de/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___at",
    path: "/at/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___es",
    path: "/es/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___uk",
    path: "/uk/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___ru",
    path: "/ru/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___ja",
    path: "/ja/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___it",
    path: "/it/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___nl",
    path: "/nl/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___pl",
    path: "/pl/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___fr",
    path: "/fr/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "home-school-lections-lection-old-1___en___default",
    path: "/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___en",
    path: "/en/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___de",
    path: "/de/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___at",
    path: "/at/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___es",
    path: "/es/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___uk",
    path: "/uk/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___ru",
    path: "/ru/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___ja",
    path: "/ja/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___it",
    path: "/it/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___nl",
    path: "/nl/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___pl",
    path: "/pl/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___fr",
    path: "/fr/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-2___en___default",
    path: "/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___en",
    path: "/en/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___de",
    path: "/de/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___at",
    path: "/at/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___es",
    path: "/es/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___uk",
    path: "/uk/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___ru",
    path: "/ru/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___ja",
    path: "/ja/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___it",
    path: "/it/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___nl",
    path: "/nl/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___pl",
    path: "/pl/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___fr",
    path: "/fr/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-3___en___default",
    path: "/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___en",
    path: "/en/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___de",
    path: "/de/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___at",
    path: "/at/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___es",
    path: "/es/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___uk",
    path: "/uk/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___ru",
    path: "/ru/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___ja",
    path: "/ja/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___it",
    path: "/it/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___nl",
    path: "/nl/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___pl",
    path: "/pl/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___fr",
    path: "/fr/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-4___en___default",
    path: "/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___en",
    path: "/en/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___de",
    path: "/de/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___at",
    path: "/at/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___es",
    path: "/es/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___uk",
    path: "/uk/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___ru",
    path: "/ru/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___ja",
    path: "/ja/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___it",
    path: "/it/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___nl",
    path: "/nl/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___pl",
    path: "/pl/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___fr",
    path: "/fr/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-5___en___default",
    path: "/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___en",
    path: "/en/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___de",
    path: "/de/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___at",
    path: "/at/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___es",
    path: "/es/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___uk",
    path: "/uk/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___ru",
    path: "/ru/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___ja",
    path: "/ja/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___it",
    path: "/it/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___nl",
    path: "/nl/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___pl",
    path: "/pl/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___fr",
    path: "/fr/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-6___en___default",
    path: "/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___en",
    path: "/en/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___de",
    path: "/de/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___at",
    path: "/at/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___es",
    path: "/es/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___uk",
    path: "/uk/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___ru",
    path: "/ru/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___ja",
    path: "/ja/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___it",
    path: "/it/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___nl",
    path: "/nl/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___pl",
    path: "/pl/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___fr",
    path: "/fr/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-questions-license___en___default",
    path: "/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___en",
    path: "/en/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___de",
    path: "/de/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___at",
    path: "/at/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___es",
    path: "/es/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___uk",
    path: "/uk/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___ru",
    path: "/ru/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___ja",
    path: "/ja/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___it",
    path: "/it/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___nl",
    path: "/nl/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___pl",
    path: "/pl/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___fr",
    path: "/fr/home/school/questions/:license()",
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___en___default",
    path: "/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___en",
    path: "/en/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___de",
    path: "/de/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___at",
    path: "/at/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___es",
    path: "/es/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___uk",
    path: "/uk/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___ru",
    path: "/ru/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___ja",
    path: "/ja/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___it",
    path: "/it/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___nl",
    path: "/nl/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___pl",
    path: "/pl/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___fr",
    path: "/fr/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "Question___en___default",
    path: "/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___en",
    path: "/en/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___de",
    path: "/de/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___at",
    path: "/at/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___es",
    path: "/es/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___uk",
    path: "/uk/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___ru",
    path: "/ru/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___ja",
    path: "/ja/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___it",
    path: "/it/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___nl",
    path: "/nl/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___pl",
    path: "/pl/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___fr",
    path: "/fr/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___en___default",
    path: "/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___en",
    path: "/en/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___de",
    path: "/de/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___at",
    path: "/at/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___es",
    path: "/es/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___uk",
    path: "/uk/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___ru",
    path: "/ru/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___ja",
    path: "/ja/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___it",
    path: "/it/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___nl",
    path: "/nl/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___pl",
    path: "/pl/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___fr",
    path: "/fr/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___en___default",
    path: "/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___en",
    path: "/en/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___de",
    path: "/de/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___at",
    path: "/at/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___es",
    path: "/es/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___uk",
    path: "/uk/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___ru",
    path: "/ru/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___ja",
    path: "/ja/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___it",
    path: "/it/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___nl",
    path: "/nl/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___pl",
    path: "/pl/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___fr",
    path: "/fr/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/at/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/uk/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/ja/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/pl/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  },
  {
    name: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4oMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubdsA5gcPAJjOBEiYlQ2n0yEWfu_xVlq62OAwNV_451sM4o
  }
]